import { ethers, ParamType } from "ethers";
const sighash = (signature) => {
    const fragment = ethers.FunctionFragment.from(signature);
    const selector = ethers.id(fragment.format()).slice(0, 10);
    return selector;
};
export const coercePermission = (permission) => {
    const selector = () => {
        if ("selector" in permission) {
            return { selector: permission.selector.toLowerCase() };
        }
        if ("signature" in permission) {
            return { selector: sighash(permission.signature) };
        }
        return {};
    };
    const condition = () => {
        if ("condition" in permission &&
            typeof permission.condition === "function") {
            return { condition: permission.condition(ParamType.from("bytes")) };
        }
        if ("condition" in permission) {
            return { condition: permission.condition };
        }
        return {};
    };
    const coerced = {
        targetAddress: permission.targetAddress.toLowerCase(),
        ...selector(),
        ...condition(),
        send: Boolean(permission.send),
        delegatecall: Boolean(permission.delegatecall),
    };
    return coerced;
};
